import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {userApi} from "../api/user-api";
import {useRecoilState} from "recoil";
import {useCleanData, userData, userLoginResultData} from "./hooks/recoilData";
import {useDocumentVisibility} from "./hooks/DocumentVisibility";

export default function AuthChecker() {
    const navigate = useNavigate();
    const [user, setUser] = useRecoilState(userData);
    const [, setUserLoginResult] = useRecoilState(userLoginResultData);
    const [cleanData] = useCleanData();
    const isVisible = useDocumentVisibility();
    useEffect(() => {
        const checkAuthPrv = () => {
            if (!isVisible)
                return;
            userApi
                .isAuth()
                .then((value) => {
                    if (!value) {
                        cleanData();
                    } else if (!user) {
                        userApi.getOwnData()
                            .then((o) => {
                                if (o) {
                                    o.isExecutor = o.roles && o.roles.includes("EXECUTOR");
                                    o.isOperator = o.roles && o.roles.includes("OPERATOR");
                                    o.isEmployer = o.roles && o.roles.includes("EMPLOYER");
                                    setUserLoginResult(o);
                                }
                            });
                        userApi.userOwnGet()
                            .then((u) => {
                                if (u) {
                                    setUser(u);
                                    navigate("/lk");
                                }
                            });
                    }
                })
                .catch(error => {
                    cleanData();
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // console.error("Server Error:", error.response.data);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        // console.error("No Response from Server:", error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        // console.error("Error setting up request:", error.message);
                    }
                });
        };
        const interval = setInterval(checkAuthPrv, 180000);
        if (!user)
            navigate("/");
        checkAuthPrv();
        return () => {
            clearInterval(interval)
        }
    }, [user, setUser, navigate, cleanData, isVisible, setUserLoginResult]);
    return (
        <div></div>
    );
}